import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import type { Contact } from '../../types/types';

interface ConfirmDeleteContactModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  deletedContact?: Contact;
  loading?: boolean;
}

export const ConfirmDeleteContactModal: React.FC<
  ConfirmDeleteContactModalProps
> = ({ show, onHide, onConfirm, deletedContact, loading }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Contact</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Are you sure you want to delete {deletedContact?.name} as a contact?
        </p>
        <p className="mb-0 text-danger fw-semibold">
          This action cannot be undone.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>

        <Button variant="danger" onClick={onConfirm} disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="me-2"
              />
              Deleting...
            </>
          ) : (
            'Delete'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
